import { Text } from '@mantine/core';
import {
  TitleCard,
  type TitleCardProps,
} from '@/_legacy-mantine/components/TitleCard/index.ts';

type DrawerTitleCardProps = TitleCardProps & {};

function DrawerTitleCard({ children, ...titleProps }: DrawerTitleCardProps) {
  return (
    <TitleCard
      bg="transparent"
      bd="transparent"
      bodySectionProps={{
        flex: 1,
      }}
      {...titleProps}
      title={
        <Text size="xs" fw={600}>
          {titleProps.title}
        </Text>
      }
    >
      {children}
    </TitleCard>
  );
}

export default DrawerTitleCard;
